import React from 'react'

const Cuub = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 793.74 157.86"
		className="w-full fill-current"
	>
		<g>
			<path d="M181.54,140.1c-18.94,11.25-43.61,17.76-71.83,17.76C44.4,157.86,0,123.92,0,78.93S44.4,0,109.71,0c28.22,0,52.89,6.51,71.83,17.76L161.61,52.49c-13.81-7.1-32.76-12-51.9-12C77,40.45,49.33,54.86,49.33,78.93S77,117.41,109.71,117.41c19.14,0,38.09-4.93,51.9-12Zm13-135.17V80.71c0,51.89,41.84,77.15,93.53,77.15s93.54-25.26,93.54-77.15V4.93H334.2V74.79c0,26-18.16,41.63-46.18,41.63s-46.17-15.59-46.17-41.63V4.93ZM406,4.93V80.71c0,51.89,41.83,77.15,93.53,77.15S593,132.6,593,80.71V4.93H545.66V74.79c0,26-18.15,41.63-46.17,41.63s-46.18-15.59-46.18-41.63V4.93Zm387.78,104c0,27.23-34.87,48.94-100,48.94-32.73,0-59.91-5.71-76.3-12.61h0V4.93H769.07l6.33,36.46L740.66,65.71C770.65,68.67,793.74,84.26,793.74,108.92Zm-129-40.47,59.36-29.94H664.78V68.45Zm81.6,38.11c0-7.11-13.25-15.58-53-15.58a173.75,173.75,0,0,0-28.58,2.14v24.63s8.32,3.79,28.58,3.79C733,121.54,746.38,114.45,746.38,106.56Z" />
		</g>
	</svg>
)

export default Cuub
